module.exports = __webpack_public_path__ + "img/Logo.1f6bc911.svg";